// NYC Congestion Zone Zip Codes
// These are areas subject to congestion pricing in Manhattan
export const congestionZoneZips = [
  "10001", // Chelsea, parts around Penn Station/Midtown South
  "10002", // Lower East Side
  "10003", // Greenwich Village, parts
  "10004", // Financial District
  "10005", // Financial District
  "10006", // Financial District/Battery Park City
  "10007", // Tribeca/City Hall
  "10009", // East Village
  "10010", // Flatiron/Gramercy
  "10011", // Chelsea/West Village
  "10012", // SoHo/NoHo
  "10013", // Tribeca/SoHo
  "10014", // West Village
  "10016", // Murray Hill
  "10017", // Midtown East
  "10018", // Garment District
  "10019", // Midtown/Hell's Kitchen, southern parts
  "10020", // Rockefeller Center area
  "10021", // Upper East Side, southern portions
  "10022", // Midtown East, southern edge
  "10036", // Times Square area, southern Midtown
  "10038", // Financial District/South Street Seaport
];

export function isInCongestionZone(zipCode) {
  if (!zipCode) return false;
  // Handle zip codes that might have the +4 extension (e.g., "10001-1234")
  const baseZip = String(zipCode).split("-")[0].trim();
  return congestionZoneZips.includes(baseZip);
}
